import { useEffect, useState } from 'react';
import {
  LazyLoadImage as LazyLoadImageUI,
  trackWindowScroll,
} from 'react-lazy-load-image-component';

import clsx from 'clsx';

import View from '@gogame/ui/View';
import { makeStyles } from '@gogame/ui/styles';

import { BrokenImageIcon } from '../Icons';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 0,
    width: '100%',
    height: '100%',
    position: 'relative',
    '& .lazy-load-image-background': {
      display: 'flex',
      justifyContent: 'center',
    },
    '& img': {
      textIndent: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    '& .lazy-load-image-background.blur': {
      // filter: 'blur(5px)',
    },
    '& .lazy-load-image-background.blur.lazy-load-image-loaded': {
      // filter: 'blur(0)',
      transition: 'all .2s',
    },
    '& .lazy-load-image-background.blur > img': {
      opacity: 0,
    },
    '& .lazy-load-image-background.blur.lazy-load-image-loaded > img': {
      opacity: 1,
      transition: 'all .2s',
      maxHeight: '100%',
    },
  },
  loader: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  relativeContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  errorPlaceholder: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    background: theme.palette.draft.main,
  },
}));

export const LazyLoadImage = ({
  src,
  key,
  alt,
  effect = 'blur',
  scrollPosition,
  visibleByDefault,
  onFallback = () => {},
  className,
  children,
}) => {
  const [loading, setLoading] = useState(!!src);
  const [hasError, setHasError] = useState(!src);

  const classes = useStyles({ hasError });

  useEffect(() => {
    setHasError(!src);
  }, [src]);

  const handleAfterLoad = () => {
    setLoading(false);
  };

  const handleError = () => {
    setLoading(false);
    setHasError(true);
    onFallback();
  };

  return (
    <div className={clsx(classes.root, className, hasError ? 'error' : null)}>
      <View loading={loading} transparent={true}>
        <span className={clsx(classes.relativeContainer, 'imageContainer')}>
          {!loading ? children : null}
          {!hasError ? (
            <LazyLoadImageUI
              wrapperProps={{
                style: {
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                },
              }}
              afterLoad={handleAfterLoad}
              onError={handleError}
              key={key}
              alt={alt}
              effect={effect}
              scrollPosition={scrollPosition}
              src={src}
              visibleByDefault={visibleByDefault}
            />
          ) : (
            <div className={clsx(classes.errorPlaceholder, 'errorPlaceholder')}>
              <BrokenImageIcon />
            </div>
          )}
        </span>
      </View>
    </div>
  );
};
export const lazyLoadTrackWindowScroll = trackWindowScroll;
